<template>
  <div class="contenedor-boton-flotante">
    <button @click="abrirModalFuentes">Fuentes</button>
    <Modal
      ref="modal_fuentes"
      posicion_boton="arriba"
      class="modal-fuentes"
      max_ancho="800px"
      max_alto="80vh"
    >
      <template #encabezado>
        <div class="encabezado">Fuentes</div>
      </template>
      <template #cuerpo>
        <h4>Hidrología</h4>
        <p>
          <b>Instituto Nacional de Estadística y Geografía </b>(2010).
          <i>Red Hidrográfica. Escala 1:50 000.</i> Edición 2.0.
          <a href="https://www.inegi.org.mx/temas/hidrografia/#Descargas"
            >https://www.inegi.org.mx/temas/hidrografia/#Descargas</a
          >
        </p>
        <p>
          <b>Instituto Nacional de Estadística y Geografía </b>(2020).
          <i
            >Conjunto de Datos Vectoriales de Información Topográfica. Escala
            1:50 000. Serie III. </i
          >
          <a
            href="https://www.inegi.org.mx/programas/topografia/50000/#Descargas"
            >https://www.inegi.org.mx/programas/topografia/50000/#Descargas</a
          >
        </p>
        <p>
          <b>Consejo Nacional de Ciencia y Tecnología </b>(2021).
          <i
            >Diagnóstico Científico y Recomendaciones para la Restauración
            Socioambiental de la Región Impactada por el Proyecto Nuevo
            Aeropuerto Internacional de la Ciudad de México. Informe
            preliminar. </i
          >
          <a
            href="https://socioecologia.conacyt.mx/texcoco/diagnostico_docs/DRNOCM_VERSI%C3%93N%20EXTENSA_ENI_2021.pdf"
            >https://socioecologia.conacyt.mx/texcoco/diagnostico_docs/DRNOCM_VERSI%C3%93N%20EXTENSA_ENI_2021.pdf</a
          >
        </p>

        <hr />
        <h4>Fauna</h4>
        <p>
          <b
            >Comisión Nacional para el Conocimiento y Uso de la Biodiversidad </b
          >(2020). Registros de ejemplares. Sistema Nacional de Información
          sobre Biodiversidad de México.
          <a href="https://www.snib.mx/ejemplares/descarga/"
            >https://www.snib.mx/ejemplares/descarga/</a
          >
        </p>

        <hr />
        <h4>Capa de uso de suelo y vegetación</h4>
        <p>
          <b
            >Capa de uso de suelo y vegetación Instituto Nacional de Estadística
            y Geografía </b
          >(2018).
          <i
            >Conjunto de datos vectoriales de uso de suelo y vegetación. Escala
            1:250 000. Serie VII. Conjunto Nacional. </i
          >
          <a
            href="https://www.inegi.org.mx/app/biblioteca/ficha.html?upc=889463842781"
            >https://www.inegi.org.mx/app/biblioteca/ficha.html?upc=889463842781</a
          >
        </p>

        <hr />
        <h4>Edafología</h4>
        <p>
          <b>Gutiérrez Castorena, M. C. </b>(2021).
          <i
            >Proyecto Fordecyt-Pronaces “Zonificación y caracterización de los
            suelos/sedimentos/rellenos del Parque Ecológico del ExLago de
            Texcoco”.</i
          >
          Colegio de Postgraduados- Conacyt.
        </p>
        <p>
          <b>Instituto Nacional de Estadística y Geografía </b>(2007).
          <i
            >Conjunto de Datos Vectoriales Edafológicos. Escala 1:250 000. Serie
            II. </i
          >
          <a href="https://www.inegi.org.mx/temas/edafologia/#Descargas"
            >https://www.inegi.org.mx/temas/edafologia/#Descargas</a
          >
        </p>
        <p>
          <b>Instituto Nacional de Estadística y Geografía </b>(2015).
          <i
            >Descripciones de suelos. Guía para la interpretación de la
            cartografía Edafología. Escala 1:250 000. Serie III. </i
          >
          <a
            href="https://www.inegi.org.mx/contenidos/productos/prod_serv/contenidos/espanol/bvinegi/productos/nueva_estruc/702825076221.pdf"
            >https://www.inegi.org.mx/contenidos/productos/prod_serv/contenidos/espanol/bvinegi/productos/nueva_estruc/702825076221.pdf</a
          >
        </p>
        <p>
          <a
            href="https://www.edafologia.org/app/download/7926525976/Cartografia+2017.pdf?t=1563476239"
            >https://www.edafologia.org/app/download/7926525976/Cartografia+2017.pdf?t=1563476239</a
          >
        </p>

        <hr />
        <h4>Delimitación del área de estudio</h4>
        <p>
          <b>Consejo Nacional de Ciencia y Tecnología </b>(2021).
          <i
            >Diagnóstico Científico y Recomendaciones para la Restauración
            Socioambiental de la Región Impactada por el Proyecto Nuevo
            Aeropuerto Internacional de la Ciudad de México. Informe
            preliminar. </i
          >
          <a
            href="https://socioecologia.conacyt.mx/texcoco/diagnostico_docs/DRNOCM_VERSI%C3%93N%20EXTENSA_ENI_2021.pdf"
            >https://socioecologia.conacyt.mx/texcoco/diagnostico_docs/DRNOCM_VERSI%C3%93N%20EXTENSA_ENI_2021.pdf</a
          >
        </p>

        <hr />
        <h4>Densidad de población y localidades</h4>
        <p>
          <b>Instituto Nacional de Estadística y Geografía </b>(2020).
          <i>Marco Geoestadístico. Censo de Población y Vivienda, 2020. </i>
          <a
            href="https://www.inegi.org.mx/app/biblioteca/ficha.html?upc=889463807469"
            >https://www.inegi.org.mx/app/biblioteca/ficha.html?upc=889463807469</a
          >
        </p>
        <p>
          <b>Instituto Nacional de Estadística y Geografía </b>(2021).
          <i
            >Principales resultados por localidad (ITER), del Censo de Población
            y Vivienda, 2020. </i
          >
          <a href="https://www.inegi.org.mx/programas/ccpv/2020/#Datos_abiertos"
            >https://www.inegi.org.mx/programas/ccpv/2020/#Datos_abiertos</a
          >
        </p>

        <hr />
        <h4>Minas</h4>
        <p>
          <b>Consejo Nacional de Ciencia y Tecnología </b>(2021).
          <i
            >Diagnóstico Científico y Recomendaciones para la Restauración
            Socioambiental de la Región Impactada por el Proyecto Nuevo
            Aeropuerto Internacional de la Ciudad de México. Informe
            preliminar. </i
          >
          <a
            href="https://socioecologia.conacyt.mx/texcoco/diagnostico_docs/DRNOCM_VERSI%C3%93N%20EXTENSA_ENI_2021.pdf"
            >https://socioecologia.conacyt.mx/texcoco/diagnostico_docs/DRNOCM_VERSI%C3%93N%20EXTENSA_ENI_2021.pdf</a
          >
        </p>
        <p>
          <b>Secretaría de Comunicaciones y Transportes </b>(2018). Inventario
          de Bancos de Materiales.
        </p>
        <p>
          <b>Servicio Geológico Mexicano </b>(2020).
          <i>Asignaciones mineras.</i>
        </p>
        <p>
          <b>Servicio Geológico Mexicano </b>(2020).
          <i
            >Cartografía Geológica de la República Mexicana. Escala 1: 250
            000. </i
          >
          <a
            href="https://datos.gob.mx/busca/dataset/cartografia-geologica-de-la-republica-mexicana-escala-1-250000"
            >https://datos.gob.mx/busca/dataset/cartografia-geologica-de-la-republica-mexicana-escala-1-250000</a
          >
        </p>

        <hr />
        <h4>Propiedades del suelo</h4>
        <p>
          <b>Gutiérrez Castorena, M. C. </b>(2021). Proyecto Fordecyt-Pronaces
          <i
            >“Zonificación y caracterización de los suelos/sedimentos/rellenos
            del Parque Ecológico del ExLago de Texcoco”</i
          >. Colegio de Postgraduados- Conacyt.
        </p>

        <hr />
        <p>
          <strong>NOTA:</strong>
          Las capas de información mostradas son el resultado del procesamiento
          de datos espaciales utilizando diferentes métodos, de acuerdo a la
          estructura, atributos y geometría de los mismos. Se eliminaron
          atributos y renombraron columnas como parte de la estructuración y
          limpieza de datos y se corrigieron las claves de las unidades
          territoriales con base en el Catálogo Único de Claves de Áreas
          Geoestadísticas Estatales, Municipales y Localidades.
        </p>
      </template>
    </Modal>
  </div>
</template>



<script>
import Modal from "@/components/base/Modal.vue";
export default {
  components: {
    Modal,
  },
  methods: {
    abrirModalFuentes() {
      console.log("abrir modal de fuentes");
      this.$refs.modal_fuentes.abrirModal();
    },
  },
};
</script>


<style lang="scss" scoped>
.contenedor-boton-flotante {
  position: absolute;
  //z-index: 5;
  bottom: 1rem;
  right: 0.5rem;
}
button {
  background-color: white;
  border: 1px solid #2e2e2e;
  font-size: 14px;
  padding: 0.5em;
  color: black;
  margin: 0;
  line-height: 1;
}
</style>

<style lang="scss">
.modal-fuentes {
  .modal-contenedor {
    border: 1px solid #a297fa;
    background: #fff;
  }
  .modal-encabezado {
    width: 100%;
    padding: 0;
    background-color: #ededff;
    border-bottom: 1px solid #a297fa;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    align-items: center;
    .encabezado {
      color: #44399f;
      font-size: 22px;
      flex-grow: 1;
      padding: 10px 15px;
    }
    .modal-cerrar {
      background-color: black !important;
      color: white !important;
      display: flex;
      flex-direction: row-reverse;
      height: 35px;
      border-radius: 5px;
      margin-right: 15px;
      &::after {
        content: "Cerrar ";
        font-size: 15px;
        margin-right: 0.4em;
      }
      &::before {
        font-size: 35px;
      }
    }
  }
  .modal-cuerpo {
    margin-top: 60px;
    // font-size: 14px;
    overflow-y: auto;
    h4 {
      font-size: 16px;
      margin: $gap * 0.5 0;
    }
    ul {
      list-style: disc;
      margin: $gap * 0.25 0;
      li {
        font-size: 14px;
      }
      ul {
        list-style: circle;
      }
    }
    ul > li::before {
      display: none;
    }
    hr {
      margin: $gap 0;
      border-color: #a297fa;
    }
    a {
      color: #2e73f7;
      word-break: break-all;
      text-decoration: underline;
      display: inline;
      font-size: 14px;
      &:hover,
      &:focus {
        background: #2e73f7;
        color: #fff;
        text-decoration: none;
      }
    }
  }
}

.dai-map-container
  > span.capas-poblacion.tooltip-abierto
  ~ div.contenedor-boton-flotante {
  bottom: 184px !important;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    bottom: 125px !important;
  }
}
</style>